/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface IHesFactory {
        
    }

    
    class HesFactory implements IHesFactory {
        static serviceId: string = "hesfactory";
        static $inject = ["$window"];

        constructor($window: angular.IWindowService) {
            if (!$window.startHesAssessmentClient) {
                console.log("Hes script not loaded.")
            }

            return $window.startHesAssessmentClient;
        }

        

    }

    angular.module("app").factory(HesFactory.serviceId, HesFactory);
}